const define = (type, prescription, returns, extra = {}) => ({
    type,
    prescription,
    returns,
    requiresEye: extra.requiresEye ?? false,
    singleLensPricing: extra.singleLensPricing ?? false,
});
/**
 * `SAL-011` fixes two groups and leaves five open.
 *
 * Fixed: "Stock frames and plano sunglasses are returnable; anything made to a prescription is not
 * returnable as of right." Ready readers follow the stock rule, being off-the-shelf magnification
 * with no dispensing.
 *
 * Open: repair, spare parts and eye test only get no position in §6.39's table, and neither do
 * contact lenses or their solutions. The last two are a genuine gap rather than a deliberate
 * silence, since a sealed contact lens box and an opened one are not the same case. All five are
 * `policy_dependent` so the tenant's policy decides, and none of it is invented here.
 */
export const SALE_TYPE_DEFINITIONS = {
    complete_spectacles: define('complete_spectacles', 'spectacle', 'made_to_specification'),
    lenses_only_own_frame: define('lenses_only_own_frame', 'spectacle', 'made_to_specification'),
    frame_only: define('frame_only', 'none', 'returnable'),
    single_lens_replacement: define('single_lens_replacement', 'spectacle', 'made_to_specification', {
        requiresEye: true,
        singleLensPricing: true,
    }),
    plano_sunglasses: define('plano_sunglasses', 'none', 'returnable'),
    prescription_sunglasses: define('prescription_sunglasses', 'spectacle', 'made_to_specification'),
    ready_readers: define('ready_readers', 'none', 'returnable'),
    contact_lenses: define('contact_lenses', 'contact_lens', 'policy_dependent'),
    cl_solutions: define('cl_solutions', 'none', 'policy_dependent'),
    repair_or_adjustment: define('repair_or_adjustment', 'none', 'policy_dependent'),
    spare_parts: define('spare_parts', 'none', 'policy_dependent'),
    eye_test_only: define('eye_test_only', 'none', 'policy_dependent'),
};
export function saleType(type) {
    return SALE_TYPE_DEFINITIONS[type];
}
//# sourceMappingURL=sale-type.js.map